export const CAMPAIGNS_DEFAULT_PATH = '/campaigns/list';
/** Product catalog + ad metrics (top-level nav, not under Campaign hub). */
export const PRODUCTS_PATH = '/products';
/** @deprecated use PRODUCTS_PATH — old campaign-hub URL */
export const CAMPAIGNS_PRODUCTS_PATH = PRODUCTS_PATH;
export const AMAZON_RULES_PATH = '/automation/amazon';

export const ADVERTISING_NAV = [
  { key: 'portfolios', label: 'Portfolios', path: '/campaigns/portfolios' },
  { key: 'list', label: 'Campaigns', path: '/campaigns/list' },
  { key: 'drafts', label: 'Drafts', path: '/campaigns/drafts' },
  { key: 'targeting-library', label: 'Targeting library', path: '/campaigns/targeting-library' },
  { key: 'budgets', label: 'Budgets', path: '/campaigns/budgets' },
  { key: 'rules', label: 'Amazon rules', path: AMAZON_RULES_PATH },
  { key: 'history', label: 'History', path: '/campaigns/history' },
  { key: 'bulk', label: 'Bulk operations', path: '/campaigns/bulk' },
  { key: 'settings', label: 'Settings', path: '/campaigns/settings' },
];

const RESERVED_SEGMENTS = new Set(
  ADVERTISING_NAV.filter((item) => item.key !== 'list').map((item) => item.key)
);

export function isCampaignsSection(pathname) {
  if (pathname.startsWith('/campaigns')) return true;
  // Campaign hub item that routes to Sellerclub Automation (Amazon rules tab).
  if (pathname === AMAZON_RULES_PATH || pathname.startsWith(`${AMAZON_RULES_PATH}/`)) {
    return true;
  }
  return false;
}

export function isAdvertisingChildActive(item, pathname) {
  if (item.key === 'list') {
    if (pathname === '/campaigns/list') return true;
    if (pathname.startsWith('/campaigns/')) {
      const segment = pathname.slice('/campaigns/'.length).split('/')[0];
      return Boolean(segment) && !RESERVED_SEGMENTS.has(segment);
    }
    return false;
  }
  if (item.key === 'rules') {
    return pathname === AMAZON_RULES_PATH || pathname.startsWith(`${AMAZON_RULES_PATH}/`);
  }
  return pathname === item.path || pathname.startsWith(`${item.path}/`);
}
